// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './fieldViewer';

/**
 * Displays a timestamp field value
 * @name TimeFieldViewer
 * @constructor
 * @extends {FieldViewer}
 */
myw.TimeFieldViewer = myw.FieldViewer.extend({
    convertValue() {
        let value = this.fieldValue;
        let parseTime, date, newTime;

        if (!value) value = '';
        else if (typeof value == 'string') {
            parseTime = value.split('T');
            if (parseTime.length == 2) {
                date = parseTime[0];

                newTime = parseTime[1].split('.');
                newTime = newTime[0];

                value = `${date} ${newTime}`;
            }
        }
        return value;
    }
});

export default myw.TimeFieldViewer;
